"use client";

import { apiClient } from "@lib/apiClient";

import { useLanguage } from "./useLanguage";

export const useApiClient = () => {
  return apiClient(useLanguage());
};
